import {writable} from 'svelte/store';

import type {
  CorporationProfilePayload,
  IndividualProfilePayload,
} from 'Utility/investorCheckout/profileTypes';

export type CommonErrors = {
  user?: Array<string>;
  profile?: Array<string>;
};

export type IndividualProfileErrors = {
  [Property in keyof IndividualProfilePayload]?: Array<string>;
} & CommonErrors;

export type CorporationProfileErrors = {
  [Property in keyof CorporationProfilePayload]?: Array<string>;
} & CommonErrors;

export type InvestorProfileErrors = IndividualProfileErrors &
  CorporationProfileErrors;

export const errors = writable<InvestorProfileErrors>({});
